// src/pages/CyborgMuseum.js

import React from 'react';

const CyborgMuseum = () => {
  return (
    <div>
      <div className='main'>
        <div className="column1"></div>
        <div className="column2">
          <br />
          <br />
          <div style={{ textAlign: 'center' }}>
            <h1>Cyborg Museum</h1>
          </div>
          <p>
            The Cybernetics, Cyberware, and Cyborg Museum project has been temporarily suspended due to financial constraints. 
            Originally envisioned as a public gallery showcasing historically significant cyberware and cyborg models, the project 
            awaits sufficient funding to proceed.
          </p>
          <p>
            In the Cyberware category, the museum plans to exhibit early computer models utilized in medical diagnostics, 
            brain-computer interfaces, prosthetics obtained from donors affected by birth defects or wartime injuries, as 
            well as microchip implants sourced from leading biomedical companies. We aim to have 
            3D printers onsite to teach others and to be used to print biomedical engineering designs and products.
          </p>
          <p>
            Meanwhile, the Cyborg models category will feature representations from diverse media, including anime, Hollywood 
            science fiction series and films, video games, and their associated franchises. We will try to if permission is 
            granted to include such media playing or playable if in video game interactive format for participants.
          </p>
          <p>
            The location entails utilizing a portion of the Sabrenetics space to house the 
            curated gallery. The museum will be aimed at all ages and open to the public free of charge following a test 
            duration for safety concern reasons.
          </p>
          <p>
            Individuals can contribute to the museum by donating electronics and medical devices related to the aforementioned 
            fields, with their contributions acknowledged through dedicated plaques displayed alongside the exhibits.
          </p>
          <p>
            Moreover, the museum welcomes volunteers interested in guiding visitors, offering an opportunity to gain 
            valuable work experience in a distinctive field.
          </p>
          <br />
          <br />
          <h2>Location</h2>
          <p>
            The Cyborg Museum is located at the Sabrenetics Office space. The exact address will be provided once the project 
            resumes and the location is finalized.
          </p>
          <br />
          <br />
          <h2>Entry</h2>
          <p>
            When the museum opens it will remain free to the public.
          </p>
          <br />
          <br />
          <h2>Donations</h2>
          <p>
            We welcome donations of goods related to cyberware, cybernetics, or cyborgs. Donors can choose to have a plaque 
            with their name included with the exhibition. Additionally, monetary donations are also accepted to help support 
            the museum's operations and future exhibits.
          </p>
          <br />
          <br />
          <h2>Disclaimer</h2>
          <p>
            While entry to the museum is free, visitors are expected to adhere to the following guidelines to ensure a 
            safe and enjoyable experience for everyone:
          </p>
          <ul>
            <li>No food or drinks are allowed inside the museum premises.</li>
            <li>Photography is permitted, but please refrain from using flash as it may damage sensitive exhibits.</li>
            <li>Please do not touch the exhibits unless explicitly stated otherwise.</li>
            <li>Children must be accompanied by an adult at all times.</li>
            <li>Respect other visitors by keeping noise levels to a minimum.</li>
            <li>Any form of vandalism or disruptive behavior will result in immediate removal from the premises.</li>
          </ul>
      </div>
      <div className="column3"></div>
    </div>
    </div >
  );
};

export default CyborgMuseum;
